<template>
  <bonus-dialog-wait
    v-bind="$attrs"
    v-on="$listeners"/>
</template>

<script>
import BonusDialogWait from './BonusDialogWait.vue'
export default {
  name: 'bonusDialogFull',
  components: {
    BonusDialogWait
  }
}
</script>



// WEBPACK FOOTER //
// src/views/xbb/components/BonusDialogFull.vue